module.exports = __webpack_public_path__ + "static/img/4.f001910.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/sp/4.png
// module id = cvKR
// module chunks = 0